module.exports = __webpack_public_path__ + "img/bigposs_logo.0bb55996.svg";